import { prettyJson } from '@/lib/format';
import { cn } from '@/lib/utils';
import { CopyButton } from '@/components/CopyButton';

/**
 * Raw JSON, rendered verbatim.
 *
 * No syntax highlighting library, no collapsible tree. The value of this panel
 * is that a developer can see exactly what the server stored, byte for byte,
 * and a highlighter that pretty prints a string differently from how it was
 * stored is a small lie in the one place the product is claiming to be honest.
 */
export function JsonBlock({
  value,
  className,
  maxHeight = '20rem',
  copyable = true,
  label,
}: {
  value: unknown;
  className?: string;
  maxHeight?: string;
  copyable?: boolean;
  label?: string;
}) {
  const text = prettyJson(value);
  return (
    <div className={cn('relative', className)}>
      {copyable ? (
        <div className="absolute top-2 right-2 z-10">
          <CopyButton value={text} label="Copy JSON" />
        </div>
      ) : null}
      <pre
        aria-label={label}
        className="overflow-auto rounded-2xl border border-border bg-muted/50 p-3 font-mono text-xs leading-relaxed"
        style={{ maxHeight }}
      >
        <code>{text}</code>
      </pre>
    </div>
  );
}
